import { render, staticRenderFns } from "./addPaIndexGroup.vue?vue&type=template&id=20b4145c&"
import script from "./addPaIndexGroup.vue?vue&type=script&lang=js&"
export * from "./addPaIndexGroup.vue?vue&type=script&lang=js&"
import style0 from "./addPaIndexGroup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports